<div class="table-wrapper pdb-50" >
  @if (koefficiente) {
    <table id="modelvariationenohnelohnbestandteile" class="hover-focus">
      <thead>
        <tr>
          <td class="no-border" rowspan="2"><br></td>
          <th rowspan="1" scope="col" colspan="3" class="header bold centered border-bold-left" translate>
          m1.sprint8.cockpit-kontrolle.modellvarianten.regression-output.col-head.abhaengige-variable</th>
          <th rowspan="1" scope="col" colspan="3" class="header bold centered border-bold-left" translate>
          m1.sprint8.cockpit-kontrolle.modellvarianten.regression-output.col-head.abhaengige-variable</th>
          <th rowspan="1" scope="col" colspan="3" class="header bold centered border-bold-left" translate>
          m1.sprint8.cockpit-kontrolle.modellvarianten.regression-output.col-head.abhaengige-variable</th>
          <th rowspan="2" scope="col" colspan="3" class="header bold centered border-bold-left" translate>
          m1.sprint8.cockpit-kontrolle.modellvarianten.regression-output.col-head.dummy-variablen</th>
          <th rowspan="2" scope="col" colspan="3" class="header bold centered border-bold-left" translate>
          m1.sprint8.cockpit-kontrolle.modellvarianten.regression-output.col-head.pq-regression</th>
          <th rowspan="2" scope="col" colspan="3" class="header bold centered border-bold-left border-bold-right" translate>
          m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.regression-output.table.colheader.sam</th>
        </tr>
        <tr>
          <td class="header bold centered border-bold-left" colspan="3" translate>
          m1.sprint8.cockpit-kontrolle.modellvarianten.regression-output.col-head.nur-grundlohn</td>
          <td class="header bold centered border-bold-left" colspan="3" translate>
          m1.sprint8.cockpit-kontrolle.modellvarianten.regression-output.col-head.ohne-zulagen</td>
          <td class="header bold centered border-bold-left" colspan="3" translate>
          m1.sprint8.cockpit-kontrolle.modellvarianten.regression-output.col-head.ohne-sonderzulagen</td>
        </tr>
        <tr>
          <td class="border-bold-left border-bold-right header"><br></td>
          @for (i of [].constructor(6); track i; let last = $last) {
            <td class="text-align-right" [ngClass]="{'shaded': last}" translate>m1.sprint8.cockpit-kontrolle.modellvarianten.koeffizient.col-head.koeffizient</td>
            <td class="text-align-right" [ngClass]="{'shaded': last}" translate>m1.sprint8.cockpit-kontrolle.modellvarianten.koeffizient.col-head.sign</td>
            <td class="text-align-right border-bold-right" [ngClass]="{'shaded': last}" translate>m1.sprint8.cockpit-kontrolle.modellvarianten.koeffizient.col-head.standardfehler</td>
          }
        </tr>
      </thead>
      <tbody>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.intercept'"
        [rowData]="koefficiente.Intercept"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.gender'"
        [rowData]="koefficiente.Gender"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ'"
        [rowData]="koefficiente.Educ"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.exp'"
        [rowData]="koefficiente.Exp"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.exp2'"
        [rowData]="koefficiente.Exp2"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.tnr'"
        [rowData]="koefficiente.Tnr"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.skl1'"
        [rowData]="koefficiente.Skl1"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.skl2'"
        [rowData]="koefficiente.Skl2"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.skl3'"
        [rowData]="koefficiente.Skl3"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.skl4'"
        [rowData]="koefficiente.Skl4"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.skl5'"
        [rowData]="koefficiente.Skl5"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.skl6'"
        [rowData]="koefficiente.Skl6"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.skl7'"
        [rowData]="koefficiente.Skl7"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.skl8'"
        [rowData]="koefficiente.Skl8"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.pos1'"
        [rowData]="koefficiente.Pos1"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.pos2'"
        [rowData]="koefficiente.Pos2"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.pos3'"
        [rowData]="koefficiente.Pos3"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.pos4'"
        [rowData]="koefficiente.Pos4"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.pos5'"
        [rowData]="koefficiente.Pos5"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ1'"
        [rowData]="koefficiente.Educ1"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ2'"
        [rowData]="koefficiente.Educ2"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ3'"
        [rowData]="koefficiente.Educ3"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ4'"
        [rowData]="koefficiente.Educ4"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ5'"
        [rowData]="koefficiente.Educ5"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ6'"
        [rowData]="koefficiente.Educ6"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ7'"
        [rowData]="koefficiente.Educ7"></tr>
        <tr appKoeffizienteTableRowData
          [caption]="'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.row-head.educ8'"
        [rowData]="koefficiente.Educ8"></tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="19" class="hint">
            {{'m1.sprint8.cockpit-kontrolle.modellvarianten.koeffiziente.footer.basis' | translate}}
          </td>
        </tr>
      </tfoot>
    </table>
  }
</div>
